/**
 * WhatsApp Test Credentials
 * These are the test credentials for WhatsApp integration testing
 * These should match the values in whatsapp_test_config.py
 */

export interface TestWhatsAppCredentials {
  access_token: string;
  app_id: string;
  app_secret: string;
  business_account_id: string;
  phone_number: string;
  phone_number_id: string;
  webhook_verify_token: string;
}

// Test credentials from whatsapp_test_config.py
export const WHATSAPP_TEST_CREDENTIALS: TestWhatsAppCredentials = {
  access_token: "EAAnUWI228jMBPdoDbZCkrWHADrFz3JLFdm3wWB4Vr7J1fS45cVEdRK6oEgluwYGlwTVDTHuddy9oB3z0WU1JElwZAmfw3hUrCzhBct97icPgoI86mZBGWZCzSf0Vxuuf9BRDrCwYOr9wAu4J5RWnQxDY5YscDRYvLl4EAjqpMcGJZCSLZAvvhvJmZCDVnYDINebTXpULNLlzucYZBSgwdSaIZAGxmMHc0jZBpYEq7dFaYwdNL4ueQmPoZAw05m1RwZDZD",
  app_id: "2766751590183475",
  app_secret: "2766751590183475",
  business_account_id: "1737898430174160",
  phone_number: "+1 555 195 2228",
  phone_number_id: "767522169771140",
  webhook_verify_token: ""
};

/**
 * Check if we're in development environment
 */
export const isDevelopment = () => {
  // Use Vite's import.meta.env (casted) for MODE; keep host fallback.
  const metaEnv: any = (import.meta as any)?.env;
  const mode = metaEnv?.MODE ?? metaEnv?.VITE_MODE ?? metaEnv?.NODE_ENV;
  const nodeEnvIsDev = mode === 'development';

  const hostIsLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  return nodeEnvIsDev || hostIsLocal;
};

/**
 * Get test credentials in the format expected by the forms
 */
export const getTestCredentials = () => {
  return {
    business_account_id: WHATSAPP_TEST_CREDENTIALS.business_account_id,
    phone_number_id: WHATSAPP_TEST_CREDENTIALS.phone_number_id,
    phone_number: WHATSAPP_TEST_CREDENTIALS.phone_number,
    access_token: WHATSAPP_TEST_CREDENTIALS.access_token,
    app_id: WHATSAPP_TEST_CREDENTIALS.app_id,
    app_secret: WHATSAPP_TEST_CREDENTIALS.app_secret,
    webhook_verify_token: WHATSAPP_TEST_CREDENTIALS.webhook_verify_token
  };
};
